const defaultTextValues = {
  title: {
    en: 'Partners'
  },
};

export default defaultTextValues;
